import { useCallback, useContext, useEffect } from "react";

import { 
    GenericDataFormContext,
    LoadSavedQuotations,
    LoadSavedQuotationsCard, 
    QuotationInfoContext,
    QuotationStep,
} from "../../../shared";
import { LOADING_RENEWAL_QUOTATION_STATES } from "../../../shared/interfaces/loading-renewal-quotation-states-enum";

const {
    INIT_LOADING_RENEWAL,
    STEP_THREE_DATA_FILLED_RENEWAL,
    FINISH_LOADING_RENEWAL,
} = LOADING_RENEWAL_QUOTATION_STATES;

export const RenewalHomeQuotation = () => {
    const { 
        renewalQuotationState,
        setRenewalQuotationState,
        setLoadingRenewalQuotation,
        setCurrentStep,
        quotationToRenewal,
    } = useContext(QuotationInfoContext);

    const { setPlansSelected } = useContext(GenericDataFormContext);

    const fillCommonStep = useCallback(() => {        
        const { bienes = [] } = quotationToRenewal as LoadSavedQuotations;

        const plansSelecteds: Array<string> = [];

        bienes.forEach(({ planSeleccionado }) => {
        if (!plansSelecteds.includes(String(planSeleccionado))) {
            plansSelecteds.push(String(planSeleccionado));
        };
        });

        setPlansSelected(plansSelecteds);
    }, [quotationToRenewal, setPlansSelected]);

     useEffect(() => {
        setRenewalQuotationState(INIT_LOADING_RENEWAL);
        fillCommonStep();
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        if(renewalQuotationState === STEP_THREE_DATA_FILLED_RENEWAL) {
            setRenewalQuotationState(FINISH_LOADING_RENEWAL);
            setLoadingRenewalQuotation(false);
            setCurrentStep(QuotationStep.THREE);
        };
    }, [renewalQuotationState]);

    return <LoadSavedQuotationsCard />;
};
